import React from 'react';
import config from 'config';
import {
  initLock,
  showLock,
  resumeAuth,
  getUserInfo
} from '../../common/auth0LockHelpers';

const stripePubKey = config.stripePubKey;
const appIconUrl =
  'https://res.cloudinary.com/dljcvcx8l/image/upload/' +
  'v1499458968/App_Icon_150x150_cophtz.png';


class BoxPay extends React.Component {
  constructor(props) {
    super(props);

    const {
      activeCoupon,
      subPrice
    } = this.getPriceAndCoupon();

    this.state = {
      trybeId: this.getQueryVariable('trybe'),
      activeCoupon,
      subPrice,
      profile: null,
      isAwaitPaymentConf: null,
      isTrybeReady: null
    };
  }

  componentWillMount(){
    this.initiateLock();
  }

  componentDidMount() {
    if(window.location.hash) {
      resumeAuth(this.lock, window.location.hash, this.onResumeAuth);
    } else {
      this.handleShowLock();
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.accessUrl && !this.props.accessUrl){
      this.setState({
        isAwaitPaymentConf: false,
        isTrybeReady: true
      })
    }
  }

  initiateLock = () => {
    this.lock = initLock({
      container: 'auth0-coach-login-container'
    });
  };

  handleShowLock = () => {
    showLock(this.lock);
  };

  onResumeAuth = (err, auth) => {
    if(!err && auth && auth.idToken) {
      console.log('lock.resumeAuth Authenticated!');
      getUserInfo(this.lock, auth.accessToken, this.onGetUserInfo)
    }

    if(err){
      console.error('lock.resumeAuth err', err);
      return;
    }
  };

  onGetUserInfo = (error, profile) => {
    if(error){
      console.error('onGetUserInfo error', error)
      return;
    }

    this.setState({ profile });

    this.loadStripe(() => {
      this.stripehandler = window.StripeCheckout.configure({
        key: stripePubKey,
        image: appIconUrl,
        locale: 'auto',
        zipCode: true,
        token: (token) => {
          this.setState({ isAwaitPaymentConf: true });

          const paymentDetails = {
            planId: 'cf_box_early_birds',
            // planId: 'trybe_test_subscription',
            trybeId: this.state.trybeId,
            accessLength: 'month',
            activeCoupon: this.state.activeCoupon
          }

          token.profile = profile;
          token.paymentDetails = paymentDetails;

          this.props.actions.signUpActions.boxPay(token);
        }
      });
    });
  };

  getPriceAndCoupon(){
    let subPrice = 1900;
    const coupons = {
      'miah_kross': {
        amount_off: 3000,
        duration: 'forever',
        id: 'miah_kross'
      }
    };

    const coupon = this.getQueryVariable('coupon');

    let activeCoupon = null;

    if(coupons[coupon]){
      activeCoupon = coupons[coupon];
      if(activeCoupon.amount_off){
        subPrice = subPrice - activeCoupon.amount_off;
      }
    }

    return {
      activeCoupon,
      subPrice
    }
  }

  loadStripe(onload:Function) {
    if(!window.StripeCheckout) {
      const script = document.createElement('script');
      script.onload = function(){
        onload();
      };
      script.src = 'https://checkout.stripe.com/checkout.js';
      document.head.appendChild(script);
    } else {
      onload();
    }
  }

  openStripe(e:Object) {
    this.stripehandler.open({
      name: 'Trybe',
      description: 'CrossFit Box - Monthly Access',
      amount: this.state.subPrice,
      allowRememberMe: false,
      image: appIconUrl,
      panelLabel: 'Subscribe',
      zipCode: true,
      email: this.state.profile ? this.state.profile.email : null
    });
  }

  getQueryVariable(key){
    var query = window.location.search.substring(1);
    var result = null;
    var vars = query.split('&');
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split('=');
      if(pair[0] == key){
        result = pair[1];
        result = result.replace('+', ' ');
        return result;
      }
    }
    return result;
  }

  goToCoachApp(){
    window.open('https://coach.trybe.do', '_blank')
  }


  renderLockView(){
    const showLock = this.state.profile ? false : true;
    const lockStyle = showLock ? null :
      { width: 0, height: 0, opacity: 0, position: 'absolute', top: -9999, left: -9999 };

    return (
      <div>
        <div style={lockStyle} className='flex-column'>
          <div className='title-text'>Monthly Access for Coaches</div>
          <div className='dots-container'>
            <div className='dot dot-active'></div>
            <div className='dot'></div>
          </div>
          <div className='steps-text'>Sign up, or log in if you already have an account.</div>
          <div id='auth0-coach-login-container' />
        </div>
      </div>
    );
  }

  renderPurchaseButton(){
    const showPurchaseScene = this.state.profile && !this.state.isTrybeReady ? true : false;
    if(!showPurchaseScene) return null;

    const showButton = this.state.isAwaitPaymentConf ?
      false : true;

    return (
      <div className='flex-column'>
        { showButton ?
          <div className='flex-column'>
            <div className='title-text'>Monthly Access for Coaches</div>
            <div className='dots-container'>
              <div className='dot'></div>
              <div className='dot dot-active'></div>
            </div>
            <div className='steps-text'>Enter payment information</div>
            <button className='custom-button' onClick={ this.openStripe.bind(this) }>
              Get Access
            </button>
          </div>
          :
          <div className='flex-column'>
            <div className='step-title-text'>One moment while we process your payment...</div>
            <div className='step-title-text'>This may take up to 15 seconds.</div>
            <div className='loader'></div>
            <div className='step-title-text'>Until directed to the confirmation page, no charge will be made.</div>
          </div>
        }
      </div>
    )
  }

  renderConfView(){
    const showConfirmation = this.state.isTrybeReady ? true : false;
    if(!showConfirmation) return null;
    return (
      <div className='flex-column align-center flex-center'>
        <div className='congrat-text'>Access Successfully Granted</div>
        <img src={require('../../images/confirmationCheckmark.png')} className='confirmation-checkmark' />

        <div className='confirmation-info-text'>To give access to athletes, simply share the following link</div>
        <div className='access-url-text'>{ this.props.accessUrl }</div>
        <div className='confirmation-info-text extra-margin-bottom'>and athletes will be guided to download the mobile app.</div>

        <div className='confirmation-info-text extra-margin-top'>For a great athlete experience, create a</div>
        <div className='confirmation-info-text'>
          workout before sharing the link.
        </div>
        <div className='congrat-text get-started-text'
          onClick={ () => this.goToCoachApp.bind(this)() }>
          Ready to get started? Head over to coach.trybe.do
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className='flex-column box-signup-container'>
        { this.renderLockView() }
        { this.renderConfView() }
        { this.renderPurchaseButton() }
      </div>
    );


  }
}

module.exports = BoxPay;



// WEBPACK FOOTER //
// ./src/components/signUp/BoxPay.js